import React, { useEffect, useState } from "react";
import { FaPlus, FaSearch } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import DropDownCustom from "../../Components/DropDownCustom/DropDownCustom";
import ReportManagementModal from "../../Components/ReportMangementModal/ReportManagementModal";
import { useSelector } from "react-redux";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import moment from "moment";
import Loader from "../../Components/Loader/Loader";
import { Logout, POPUP, refreshToken } from "../../Actions/actions";
import { useDispatch } from "react-redux";
import ReportManagementModalClient from "../../Components/ReportMangementModal/ReportManagementModalClient";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
const ReportManagementTable = () => {
  const { loginData, role, Privilages } = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();

  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("");
  const [masterReports, setMasterReports] = useState([]);
  const [filteredReports, setFilteredReports] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenClient, setIsModalOpenClient] = useState(false);
  const [loader, setLoader] = useState(false);
  const [checker, setChecker] = useState(false);

  const reportFilterOptions = [
    { value: "", label: "All" },
    { value: "Client", label: "Client" },
    { value: "Subscription", label: "Subscription" },
    { value: "Transaction", label: "Transaction" },
  ];
  const reportFilterOptionsClients = [
    { value: "", label: "All" },
    { value: "call-logs", label: "Call Logs Report" },
    { value: "lead-pipeline-report", label: "Lead Pipeline Report" },
    { value: "prospect-leads", label: "Prospect Lead Report" },
    { value: "business-loss", label: "Business Lost Report" },
    { value: "visit", label: "Visit Report" },
    { value: "performance", label: "Performance Report" },
  ];
  useEffect(() => {
    if (role == "Admin") {
      getAllReports();
    } else {
      getAllReportsClient();
    }
  }, [checker]);

  useEffect(() => {
    applySearchAndFilter();
  }, [searchTerm, filterType, masterReports]);

  const getAllReports = () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");

      setLoader(true);
      fetch(`${BaseUrl}/api/reports`, {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      })
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(loginData?.accessToken, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          setMasterReports(result?.reports || []);
          setLoader(false);
        })
        .catch((error) => {
          setLoader(false);
          console.error(error);
        });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  const getAllReportsClient = () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");

      setLoader(true);
      fetch(`${BaseUrl}/api/report/list`, {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      })
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(loginData?.accessToken, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log(result, "res");
          setMasterReports(result?.reports || []);
          setLoader(false);
        })
        .catch((error) => {
          setLoader(false);
          console.error(error);
        });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  const getReportById = (id) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");

      fetch(`${BaseUrl}/api/reports/${id}`, {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      })
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(loginData?.accessToken, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          console.log("report by id response", result);

          let csvData = [];
          const reportType = result?.report?.reportType;
          const wrapText = (value) => `="${String(value ?? "").replace(/"/g, '""')}"`;

          if (reportType === "Transaction") {
            csvData = [
              [
                "Invoice Number",
                "Invoice Date",
                "Payment Date",
                "Amount",
                "Currency",
                "Payment Method",
                "Payment Status",
                "Subscription Type",
                "Description",
                "Expiry Date",
                "Client Business Name",
                "Client Email",
                "Client Contact Phone",
              ],
              ...result.data.map((item) =>
                [
                  item.invoiceNumber,
                  moment(item.invoiceDate).format("DD-MMM-yy"),
                  moment(item.paymentDate).format("DD-MMM-yy"),
                  item.amount,
                  item.currency,
                  item.paymentMethod,
                  item.paymentStatus,
                  item.subscriptionType,
                  item.description,
                  moment(item.expiryDate).format("DD-MMM-yy"),
                  item.client.businessName,
                  item.client.email,
                  String(item.client.contactPersonPhoneNumber),
                ].map(wrapText)
              ),
            ];
          } else if (reportType === "Client") {
            csvData = [
              [
                "Business Name",
                "Contact Name",
                "Contact Phone",
                "Email",
                "City",
                "Country",
                "Industry",
                "Company Activity",
                "VAT/TAX ID",
                "Trade License Number",
                "Subscription Type",
                "Subscription Expiry",
                "Created At",
                "Payment Status",
              ],
              ...result.data.map((item) =>
                [
                  item.businessName,
                  item.contactPersonName,
                  String(item.contactPersonPhoneNumber),
                  item.email,
                  item.businessCity,
                  item.businessCountry,
                  item.clientIndustry,
                  item.companyActivity,
                  item.vatTaxId,
                  item.tradeLicenseNumber,
                  item.subscriptionType,
                  moment(item.subscriptionExpiryDate).format("DD-MMM-yy"),
                  moment(item.createdAt).format("DD-MMM-yy"),
                  item.paymentStatus,
                ].map(wrapText)
              ),
            ];
          } else if (reportType === "Subscription") {
            csvData = [
              [
                "Client Name",
                "Company",
                "Created At",
                "Email",
                "Industry",
                "Package",
                "Phone Number",
                "Sales Team Head Count",
                "Status",
              ],
              ...result.data.map((item) =>
                [
                  item.name,
                  item.company,
                  moment(item.createdAt).format("DD-MMM-yy"),
                  item.email,
                  item.industry,
                  item.package,
                  String(item.phoneNumber),
                  item.salesTeamHeadcount,
                  item.status,
                ].map(wrapText)
              ),
            ];
          } else {
            console.warn("Unknown report type:", reportType);
            return;
          }

          const csvString = csvData.map((row) => row.join(",")).join("\n");
          const blob = new Blob([csvString], { type: "text/csv" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.setAttribute("href", url);
          a.setAttribute(
            "download",
            `${reportType}-reports-${moment(result?.report?.startDate).format("DD-MMM-yy")}-${moment(
              result?.report?.endDate
            ).format("DD-MMM-yy")}.csv`
          );
          a.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const getReportByIdClient = (id, type) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");

      fetch(`${BaseUrl}/api/report/data/${type}/${id}`, {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      })
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(loginData?.accessToken, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then(async (result) => {
          console.log("report by id response", result);
          // return
          let csvData = [];
          const reportType = result?.reportType;
          const wrapText = (value) => `="${String(value ?? "").replace(/"/g, '""')}"`;

          if (reportType === "business-loss") {
            csvData = [
              [
                "BDE",
                "Company Name",
                "Contact Person",
                "Contact Number",
                "Email Address",
                "Competitor Name",
                "Number Of units Required",
                "Revenue Loss",
                "Contract Type",
                "Expected Closure Month",
                "Remarks",
              ],
              ...result.data.map((item) =>
                [
                  item.BDE,
                  item["Company Name"],
                  item["Contact Person"],
                  item["Contact Number"],
                  item["Email Address"],
                  item["Competitor Name"],
                  item["Number Of units Required"],
                  item["Revenue Loss"],
                  item["Contract Type"],
                  item["Expected Closure Month"],
                  item["Remarks"],
                ].map(wrapText)
              ),
            ];
          } else if (reportType === "visit") {
            csvData = [
              [
                "BDE Name",
                "Company Name",
                "Account Type",
                "Contact Person",
                "Contact Number",
                "Area (Location)",
                "Purpose of Meeting",
                "Remarks",
              ],
              ...result.data.map((item) =>
                [
                  item["BDE Name"],
                  item["Company Name"],
                  item["Account Type"],
                  item["Contact Person"],
                  item["Contact Number"],
                  item["Area (Location)"],
                  item["Purpose of Meeting"],
                  item["Remarks"],
                ].map(wrapText)
              ),
            ];
          } else if (reportType === "prospect-leads") {
            csvData = [
              [
                "BDE",
                "Company Name",
                "Contact Person",
                "Contact Number",
                "Email Address",
                "Competitor Name",
                "Number Of units Required",
                "Expected Revenue",
                "Expected Closure Month",
                "Remarks",
              ],
              ...result.data.map((item) =>
                [
                  item?.BDE,
                  item["Company Name"],
                  item["Contact Person"],
                  item["Contact Number"],
                  item["Email Address"],
                  item["Competitor Name"],
                  item["Number Of units Required"],
                  item["Expected Revenue"],
                  item["Expected Closure Month"],
                  item["Remarks"],
                ].map(wrapText)
              ),
            ];
          } else if (reportType === "call-logs") {
            csvData = [
              [
                "BDE",
                "Company Name",
                "Contact Person",
                "Contact Number",
                "Email Address",
                "Competitor Name",
                "Number Of units Required",
                "Expected Revenue",
                "Expected Closure Month",
                "Remarks",
              ],
              ...result.data.map((item) =>
                [
                  item?.BDE,
                  item["Company Name"],
                  item["Contact Person"],
                  item["Contact Number"],
                  item["Email Address"],
                  item["Competitor Name"],
                  item["Number Of units Required"],
                  item["Expected Revenue"],
                  item["Expected Closure Month"],
                  item["Remarks"],
                ].map(wrapText)
              ),
            ];
          } else if (reportType === "performance") {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("BDE Report");

            // === Merge & Set Headers based on your latest screenshot ===

            // Row 2
            worksheet.mergeCells("B2:B4");
            worksheet.getCell("B2").value = "BDE Name";

            worksheet.mergeCells("C2:D2");
            worksheet.getCell("C2").value = "Target Allocation";
            worksheet.mergeCells("C3:C4");
            worksheet.getCell("C3").value = "No Of Units";
            worksheet.mergeCells("D3:D4");
            worksheet.getCell("D3").value = "Revenue";

            worksheet.mergeCells("E2:F2");
            worksheet.getCell("E2").value = "Total Achievement";
            worksheet.mergeCells("E3:E4");
            worksheet.getCell("E3").value = "No Of Units";
            worksheet.mergeCells("F3:F4");
            worksheet.getCell("F3").value = "Revenue";

            worksheet.mergeCells("G2:J2");
            worksheet.getCell("G2").value = "Business Generated from";
            worksheet.mergeCells("G3:H3");
            worksheet.getCell("G3").value = "Existing Accounts";
            worksheet.getCell("G4").value = "No Of Units";
            worksheet.getCell("H4").value = "Revenue";
            worksheet.mergeCells("I3:J3");
            worksheet.getCell("I3").value = "New Accounts";
            worksheet.getCell("I4").value = "No Of Units";
            worksheet.getCell("J4").value = "Revenue";

            worksheet.mergeCells("K2:L2");
            worksheet.getCell("K2").value = "No Of new Corporate Accounts Opened";
            worksheet.mergeCells("K3:K4");
            worksheet.getCell("K3").value = "Target";
            worksheet.mergeCells("L3:L4");
            worksheet.getCell("L3").value = "Achievement";

            worksheet.mergeCells("M2:N2");
            worksheet.getCell("M2").value = "Achievement Percentage";
            worksheet.mergeCells("M3:M4");
            worksheet.getCell("M3").value = "Monthly";
            worksheet.mergeCells("N3:N4");
            worksheet.getCell("N3").value = "Quarter";

            // === Style All Header Rows ===
            for (let row = 2; row <= 4; row++) {
              worksheet.getRow(row).eachCell((cell) => {
                cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
                cell.font = { bold: true };
                cell.border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
                };
              });
            }

            // === Add data starting from row 5 ===
            result?.data.forEach((item) => {
              worksheet.addRow([
                "",
                item["BDE Name"],
                item["TAlloc-NoOfUnits"],
                item["TAlloc-Rev"],
                item["TAchiev-NoOfUnits"],
                item["TAchiev-Rev"],
                item["EA-NoOfUnits"],
                item["EA-Rev"],
                item["NA-NoOfUnits"],
                item["NA-Rev"],
                item["Target"],
                item["Achievement"],
                item["Monthly"],
                item["Quaterly"],
              ]);
            });

            // === Export Excel File ===
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(
              blob,
              `${reportType}-reports-${moment(result?.report?.startDate).format("DD-MMM-yy")}-${moment(
                result?.report?.endDate
              ).format("DD-MMM-yy")}.csv`
            );
          } else if (reportType === "lead-pipeline-report") {
            const categoryObj = {
              Cold: ["Contacted", "Followup", "Prospect"],
              Warm: ["UnderNegotiations", "Quotationsent", "AwaitingReceived"],
              Hot: [
                "Pending with Admin",
                "MasterAgreementnegotiations",
                "AccountOpeninginprocess",
                "Accountconverted",
                "ReceivedConfirmationofExecution",
              ],
            };
            csvData = [
              [
                "SL",
                "CATEGORY",
                "RECEIVED IN",
                "EXPECTED IN",
                "COMPANY NAME",
                "CONTACT NUMBER",
                "CUSTOMER TYPE",
                "NO.OF VEHICLE",
                "TENURE",
                "VEHICLE",
                "CONTRACT",
                "REVENUE",
                "REMARKS",
              ],
              ...result.data.map((item, index) => {
                const category =
                  Object.keys(categoryObj).find((key) => categoryObj[key].includes(item.Status)) || "Unknown Status";
                return [
                  index + 1,
                  category,
                  item["RECEIVED IN"],
                  item["EXPECTED IN"],
                  item["COMPANY NAME"],
                  item["Contact Number"],
                  item["CUSTOMER TYPE"],
                  item["NO.OF VEHICLE"],
                  item["TENURE"],
                  item["VEHICLE"],
                  item["CONTRACT"],
                  item["EXPECTED REVENUE"],
                  item["Remarks"],
                ].map(wrapText);
              }),
            ];
          } else {
            console.warn("Unknown report type:", reportType);
            return;
          }

          const csvString = csvData.map((row) => row.join(",")).join("\n");
          const blob = new Blob([csvString], { type: "text/csv" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.setAttribute("href", url);
          a.setAttribute(
            "download",
            `${reportType}-reports-${moment(result?.report?.startDate).format("DD-MMM-yy")}-${moment(
              result?.report?.endDate
            ).format("DD-MMM-yy")}.csv`
          );
          a.click();
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleFilterChange = (selectedOption) => {
    setFilterType(selectedOption.value);
  };

  const applySearchAndFilter = () => {
    let filtered = masterReports;
    if (searchTerm) {
      filtered = filtered.filter(
        (report) =>
          report.reportName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          report.name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (filterType) {
      filtered = filtered.filter((report) => report.reportType === filterType);
    }

    setFilteredReports(filtered);
  };

  const PrivilagesArray =
    Privilages?.length > 0 ? Privilages.filter((item) => item.feature === "Report Management") : [];

  ///////////////////////

  const downloadBusinessLossReportClient = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("BusinessLossReport");

    // Style presets
    const headerFill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF44546A" } };
    const subHeaderFill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF00" } };
    const lightBlueFill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFDAEEF3" } };
    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    // 1. Main Title
    worksheet.mergeCells("A1:D1");
    worksheet.getCell("A1").value = "BUSINESS LOSS";
    worksheet.getCell("A1").font = { bold: true, color: { argb: "FFFFFFFF" }, size: 14 };
    worksheet.getCell("A1").alignment = { horizontal: "center" };
    worksheet.getCell("A1").fill = headerFill;

    // 2. Subheaders
    worksheet.mergeCells("A2:A3");
    worksheet.mergeCells("B2:B3");
    worksheet.mergeCells("C2:D2");

    worksheet.getCell("A2").value = "SN";
    worksheet.getCell("B2").value = "REGION";
    worksheet.getCell("C2").value = "TOTAL";
    worksheet.getCell("C3").value = "MRA";
    worksheet.getCell("D3").value = "LES";

    ["A2", "B2", "C2", "C3", "D3"].forEach((cell) => {
      const c = worksheet.getCell(cell);
      // Apply headerFill only to A2, B2, and C2
      if (["A2", "B2", "C2"].includes(cell)) {
        c.fill = headerFill;
        c.font = { bold: true, color: { argb: "FFFFFFFF" } }; // white font
      } else {
        c.fill = subHeaderFill;
        c.font = { bold: true, color: { argb: "FF000000" } }; // black font
      }
      c.alignment = { horizontal: "center", vertical: "middle" };
      c.border = borderStyle;
    });

    // 3. Region Row
    worksheet.getCell("A4").value = 1;
    worksheet.getCell("B4").value = "DXB SALES";
    ["A4", "B4", "C4", "D4"].forEach((cell) => {
      const c = worksheet.getCell(cell);
      c.border = borderStyle;
      if (["B4"].includes(cell)) {
        c.font = { bold: true };
      }
      c.alignment = { horizontal: "center", vertical: "middle" };
    });
    worksheet.getCell("C4").value = "2"; // or actual value
    worksheet.getCell("D4").value = "4"; // or actual value
    // 4. Total Off Hires
    worksheet.mergeCells("A5:B5");
    worksheet.mergeCells("C5:D5");
    worksheet.getCell("A5").value = "TOTAL OFF-HIRES";
    worksheet.getCell("C5").value = 0;

    ["A5", "C5"].forEach((cell) => {
      const c = worksheet.getCell(cell);
      c.fill = lightBlueFill;
      c.font = { bold: true };
      c.alignment = { horizontal: "center", vertical: "middle" };
      c.border = borderStyle;
    });

    // 5. Spacer Row
    worksheet.addRow([]); // This will be row 6

    // 6. Table Header (now row 7)
    const tableHeaders = [
      "SN",
      "CUSTOMER",
      "CONTRACT TYPE",
      "NO. OF UNITS",
      "TENURE",
      "VEHICLE TYPE",
      "REASON FOR OFF HIRE",
      "SALES PERSON",
      "ANNUAL REVENUE LOSS",
    ];
    const headerRowIndex = worksheet.lastRow.number + 1;
    worksheet.addRow(tableHeaders);
    const headerRow = worksheet.getRow(headerRowIndex);

    headerRow.eachCell((cell) => {
      cell.fill = headerFill;
      cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12 };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = borderStyle;
    });

    // 7. Data Rows
    const rows = [
      [1, "Wolfkraan", "MRA", 1, "Monthly", "Nissan Sunny/Mitsb Attrage", "No Availability", "Hamid Khan", "21,588"],
      [2, "Kuwait Airways", "MRA", 1, "Monthly", "Toyota Prado/Pajero", "No Availability", "Hamid Khan", "57,000"],
      [3, "Lamprel Energy", "MRA", 1, "Monthly", "Nissan Patrol", "No Availability", "Hamid Khan", "144,000"],
      [4, "ASGC Group", "MRA", 3, "Monthly", "Nissan Sunny", "No Availability", "Hamid Khan", "64,764"],
      [5, "IMC", "MRA", 1, "Monthly", "Nissan Patrol", "Not confirmed by the Customer", "Hamid Khan", "144,000"],
      [
        6,
        "Harshad - Taaleem",
        "MRA",
        1,
        "Monthly",
        "Mitsb Attrage",
        "We were late getting approval for 1500",
        "Hamid Khan",
        "18,000",
      ],
      [
        7,
        "SWML Fujairah",
        "MRA",
        2,
        "Monthly",
        "Mitsb ASX",
        "They get low price from Competitor",
        "Hamid Khan",
        "64,776",
      ],
      [8, "IYYM", "MRA", 1, "Monthly", "Nissan Sunny/Attrage", "No Availability", "Hamid Khan", "21,588"],
      [
        9,
        "Access Hire",
        "LES",
        1,
        "1 Year",
        "Mitsb ASX",
        "He get low price from Competitor for Mazda CX-5",
        "Hamid Khan",
        "28,788",
      ],
      [
        10,
        "Ravinder - Simfoni",
        "MRA",
        1,
        "Monthly",
        "Xtrail/Rav-4/Sportage",
        "He get low price from Competitor for Xtrail",
        "Hamid Khan",
        "36,000",
      ],
    ];

    rows.forEach((row) => worksheet.addRow(row));

    // 8. Apply styling to all data rows
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber > headerRowIndex) {
        row.eachCell((cell) => {
          cell.border = borderStyle;
          cell.alignment = { vertical: "middle", horizontal: "left" };
        });
      }
    });

    // 9. Column widths
    const colWidths = [5, 22, 15, 14, 12, 30, 40, 18, 20];
    colWidths.forEach((width, i) => {
      worksheet.getColumn(i + 1).width = width;
    });

    // 10. Freeze header
    worksheet.views = [{ state: "frozen", ySplit: headerRowIndex }];

    // 11. Download file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, "BusinessLossReport.xlsx");
  };
  const downloadCallLogsDataReportClient = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("CallLogsData");

    // Colors and styles
    const headerFill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF7B3F3F" } }; // maroon
    const lightMaroonFill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE6B8B7" } }; // light maroon (Excel-compatible)
    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    // Merge and title cell
    worksheet.mergeCells("A2:G2");
    const titleCell = worksheet.getCell("A2");
    titleCell.value = "COLD CALL LOG REPORT";
    titleCell.font = { bold: true, size: 14, color: { argb: "FFFFFFFF" } };
    titleCell.alignment = { horizontal: "center" };
    titleCell.fill = headerFill;

    // Table headers
    const tableHeaders = [
      "S.no.",
      "Company name",
      "Tel No.",
      "Contact Person",
      "Email",
      "Remarks",
      "PROSPECT (YES/NO)",
    ];
    const headerRowIndex = worksheet.lastRow.number + 1;
    worksheet.addRow(tableHeaders);

    const headerRow = worksheet.getRow(3);
    headerRow.eachCell((cell) => {
      cell.fill = lightMaroonFill;
      cell.font = { bold: true, color: { argb: "FF000000" } }; // black text
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = borderStyle;
    });

    // Data rows
    const data = [
      [
        1,
        "GCC Marketing",
        "056 730 0783",
        "Mr.Franlk",
        "",
        "Company has it own fleet. Very Rare requirment of Car rental",
        "No",
      ],
      [
        2,
        "Valtech_Revonic",
        "04 225 0572",
        "",
        "",
        "Company has it own fleet. Very Rare requirment of Car rental",
        "No",
      ],
      [3, "ORYX MIX (Dubai)", "04 459 8700", "Mr.Joshi", "", "044598777 Call back request for tommorow", "Yes"],
      [4, "Al Ghurair Construction Readymix LLC", "04 350 2100", "Mr.Sunil", "", "Company owned fleet.", "No"],
      [5, "DMIX", "04 880 1141", "Ms.Fatima", "", "Company owned fleet.", "No"],
      [6, "Emirates Beton Readymix L.L.C", "04 320 9207", "Ms.Joy", "", "Company owned fleet.", "No"],
      [7, "GRM LLC", "04 880 3553", "Mr.Gibin", "", "Rare Car rental requirments.", "No"],
      [8, "Top Concrete Products Factory", "06 882 6066", "Mr.Biju", "", "Company owned fleet. 30+ Vehicles", "No"],
      [9, "MAXIITO", "04 320 5599", "Mr.Jim", "", "Company owned fleet.", "Yes"],
      [10, "Redbox Digital ME", "04 319 9327", "Ms.Frank", "", "", ""],
    ];

    data.forEach((row) => worksheet.addRow(row));

    // Style data rows
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber >= 5) {
        row.eachCell((cell) => {
          cell.border = borderStyle;
          cell.alignment = { vertical: "middle", horizontal: "left" };
        });
      }
    });

    // Adjust column widths
    const colWidths = [8, 30, 15, 18, 25, 60, 20];
    colWidths.forEach((width, i) => {
      worksheet.getColumn(i + 1).width = width;
    });

    // Freeze header rows
    worksheet.views = [{ state: "frozen", ySplit: 4 }];

    // Generate and download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "CallLogsData.xlsx");
  };
  const downloadPerformanceReviewReportClient = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("PerformanceReviewReport");

    // Styles
    const blueFill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF588CD4" } }; // light blue
    const whiteFont = { bold: true, color: { argb: "FF000000" } };
    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    // Table Headers
    const headers = [
      "Sr No",
      "Cust Type",
      "CNTYP",
      "DOCNO",
      "STATUS",
      "CLOSED DATE",
      "REGNO",
      "FNAME",
      "SALESMAN",
      "Total",
      "Veh Type",
    ];
    worksheet.addRow(headers);

    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell, colNumber) => {
      // Apply black background for most, blue for columns H–K
      cell.fill = blueFill;
      cell.font = whiteFont;
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = borderStyle;
    });

    // Data Rows (based on your image)
    const rows = [
      [
        1,
        "Corporate",
        "LES",
        4172000020,
        "CLOSE",
        "04-Mar-25",
        "AUH-37930-18",
        "ARCHIRODON CONSTRUCTION (OVERSEAS) COMPANY LIMITED",
        "Hamid Khan",
        1750,
        "MITSUBISHI ASX GLX 2WD BA 2022",
      ],
      [
        2,
        "Corporate",
        "LES",
        4362100033,
        "CLOSE",
        "10-Mar-25",
        "DXB-98643-X",
        "AL TANMYAH SERVICES LLC",
        "Hamid Khan",
        2300,
        "NISSAN URVAN 6STR 2021",
      ],
      [
        3,
        "Corporate",
        "LES",
        4362100034,
        "CLOSE",
        "10-Mar-25",
        "DXB-90787-Q",
        "AL TANMYAH SERVICES LLC",
        "Hamid Khan",
        2300,
        "NISSAN URVAN 6STR 2.5L 2022",
      ],
      [
        4,
        "Corporate",
        "MRA",
        4362400004,
        "CLOSE",
        "03-Mar-25",
        "DXB-23410-E",
        "EMIRATES FIRE PROTECTIONS EQUIP. FACTORY TR. SECTION LLC SP",
        "Puneet",
        3750,
        "MITSUBISHI L200 GL D/CAB 2WD 2023",
      ],
      [
        5,
        "Corporate",
        "MRA",
        4172400344,
        "CLOSE",
        "08-Mar-25",
        "DXB-15317-AA",
        "AG AUTO TRADING LLC",
        "Puneet",
        2390,
        "EXEED MY25 LX COMFORT 1.5 2025",
      ],
      [
        6,
        "Corporate",
        "MRA",
        4172400370,
        "CLOSE",
        "06-Mar-25",
        "AUH-75021-7",
        "NEO DELIVERY SERVICES LLC",
        "RAZA SAEED",
        1500,
        "MG MG 5 COM 1.5L 2023",
      ],
      [
        7,
        "Individual",
        "MRA",
        4172400373,
        "CLOSE",
        "06-Mar-25",
        "AUH-85303-5",
        "ALEXANDRU DRAGOS MOLDOVAN",
        "RAZA SAEED",
        2100,
        "JAC J 7–SEDAN–1.5 LIT 2024",
      ],
      [
        8,
        "Corporate",
        "MRA",
        4172400386,
        "CLOSE",
        "06-Mar-25",
        "AUH-39325-9",
        "NEO DELIVERY SERVICES LLC",
        "RAZA SAEED",
        1500,
        "MG MG5 1.5L STD 2024",
      ],
      [
        9,
        "Corporate",
        "MRA",
        4172400389,
        "CLOSE",
        "06-Mar-25",
        "AUH-75182-7",
        "NEO DELIVERY SERVICES LLC",
        "RAZA SAEED",
        1500,
        "MG MG 5 COM 1.5L 2023",
      ],
      [
        10,
        "Corporate",
        "MRA",
        4172400390,
        "CLOSE",
        "06-Mar-25",
        "AUH-35675-19",
        "NEO DELIVERY SERVICES LLC",
        "RAZA SAEED",
        1500,
        "MG MG5 1.5L STD 2024",
      ],
      [
        11,
        "Individual",
        "MRA",
        4172500003,
        "CLOSE",
        "05-Mar-25",
        "AUH-26702-7",
        "SYED AHAD HASSAN NAEEM",
        "Erum Khan",
        1600,
        "NISSAN SUNNY SV 1.5L AT REV CAM 2024",
      ],
      [
        12,
        "Individual",
        "MRA",
        2532500035,
        "CLOSE",
        "10-Mar-25",
        "AUH-23489-16",
        "MAJD GHASSA",
        "Hamid Khan",
        1580,
        "MG MG3 1.5L STD H/B REV CAM 2025",
      ],
      [
        13,
        "Corporate",
        "MRA",
        4172500029,
        "CLOSE",
        "03-Mar-25",
        "AUH-37927-18",
        "ARCHIRODON CONSTRUCTION (OVERSEAS) COMPANY LIMITED",
        "Hamid Khan",
        2390,
        "MITSUBISHI ASX GLX 2WD BA 2022",
      ],
    ];

    rows.forEach((row) => worksheet.addRow(row));

    // Apply border & alignment to data rows
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber > 1) {
        row.eachCell((cell) => {
          cell.border = borderStyle;
          cell.alignment = { vertical: "middle", horizontal: "left" };
        });
      }
    });

    // Set column widths
    const colWidths = [6, 12, 10, 14, 10, 14, 15, 50, 15, 10, 40];
    colWidths.forEach((w, i) => {
      worksheet.getColumn(i + 1).width = w;
    });

    // Freeze header
    worksheet.views = [{ state: "frozen", ySplit: 1 }];

    // Download file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "PerformanceReviewReport.xlsx");
  };
  const downloadCorporateProspectsReportClient = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("CorporateProspects");

    // Styles
    const blueFill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF588CD4" } }; // light blue
    const whiteFont = { bold: true, color: { argb: "FF000000" } };
    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    // Table Headers
    const headers = [
      "Sr No",
      "Company name",
      "Contract person",
      "Contact  number",
      "Email address",
      "Current supplier",
      "No. of hired vehicles",
      "Remarks",
    ];
    worksheet.addRow(headers);

    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell, colNumber) => {
      // Apply black background for most, blue for columns H–K
      cell.fill = blueFill;
      cell.font = whiteFont;
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = borderStyle;
    });

    // Data Rows (based on your image)
    const rows = [
      [
        1,
        "Corporate",
        "LES",
        4172000020,
        "leonardo.reyes@strongplant.com",
        "04-Mar-25",
        "AUH-37930-18",
        "ARCHIRODON CONSTRUCTION (OVERSEAS) COMPANY LIMITED",
      ],
      [
        2,
        "Corporate",
        "LES",
        4362100033,
        "leonardo.reyes@strongplant.com",
        "10-Mar-25",
        "DXB-98643-X",
        "AL TANMYAH SERVICES LLC",
      ],
      [
        3,
        "Corporate",
        "LES",
        4362100034,
        "leonardo.reyes@strongplant.com",
        "10-Mar-25",
        "DXB-90787-Q",
        "AL TANMYAH SERVICES LLC",
      ],
      [
        4,
        "Corporate",
        "MRA",
        4362400004,
        "leonardo.reyes@strongplant.com",
        "03-Mar-25",
        "DXB-23410-E",
        "EMIRATES FIRE PROTECTIONS EQUIP. FACTORY TR. SECTION LLC SP",
      ],
      [
        5,
        "Corporate",
        "MRA",
        4172400344,
        "leonardo.reyes@strongplant.com",
        "08-Mar-25",
        "DXB-15317-AA",
        "AG AUTO TRADING LLC",
      ],
      [
        6,
        "Corporate",
        "MRA",
        4172400370,
        "leonardo.reyes@strongplant.com",
        "06-Mar-25",
        "AUH-75021-7",
        "NEO DELIVERY SERVICES LLC",
      ],
      [
        7,
        "Individual",
        "MRA",
        4172400373,
        "leonardo.reyes@strongplant.com",
        "06-Mar-25",
        "AUH-85303-5",
        "ALEXANDRU DRAGOS MOLDOVAN",
      ],
      [
        8,
        "Corporate",
        "MRA",
        4172400386,
        "leonardo.reyes@strongplant.com",
        "06-Mar-25",
        "AUH-39325-9",
        "NEO DELIVERY SERVICES LLC",
      ],
      [
        9,
        "Corporate",
        "MRA",
        4172400389,
        "leonardo.reyes@strongplant.com",
        "06-Mar-25",
        "AUH-75182-7",
        "NEO DELIVERY SERVICES LLC",
      ],
      [
        10,
        "Corporate",
        "MRA",
        4172400390,
        "leonardo.reyes@strongplant.com",
        "06-Mar-25",
        "AUH-35675-19",
        "NEO DELIVERY SERVICES LLC",
      ],
      [
        11,
        "Individual",
        "MRA",
        4172500003,
        "leonardo.reyes@strongplant.com",
        "05-Mar-25",
        "AUH-26702-7",
        "SYED AHAD HASSAN NAEEM",
      ],
      [
        12,
        "Individual",
        "MRA",
        2532500035,
        "leonardo.reyes@strongplant.com",
        "10-Mar-25",
        "AUH-23489-16",
        "MAJD GHASSA",
      ],
      [
        13,
        "Corporate",
        "MRA",
        4172500029,
        "leonardo.reyes@strongplant.com",
        "03-Mar-25",
        "AUH-37927-18",
        "ARCHIRODON CONSTRUCTION (OVERSEAS) COMPANY LIMITED",
      ],
    ];

    rows.forEach((row) => worksheet.addRow(row));

    // Apply border & alignment to data rows
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber > 1) {
        row.eachCell((cell) => {
          cell.border = borderStyle;
          cell.alignment = { vertical: "middle", horizontal: "left" };
        });
      }
    });

    // Set column widths
    const colWidths = [6, 12, 10, 14, 10, 14, 15, 50, 15, 10, 40];
    colWidths.forEach((w, i) => {
      worksheet.getColumn(i + 1).width = w;
    });

    // Freeze header
    worksheet.views = [{ state: "frozen", ySplit: 1 }];

    // Download file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "CorporateProspects.xlsx");
  };
  ////////////////////
  // const initialReportsData = [
  //   {
  //     reportName: "Business Loss Report",
  //     reportType: "Sales Report",
  //     dateGenerated: "2024-08-15",
  //     onClick: () => downloadBusinessLossReportClient()
  //   },
  //   {
  //     reportName: "Call Log Report",
  //     reportType: "Inventory Report",
  //     dateGenerated: "2024-08-12",
  //     onClick: () => downloadCallLogsDataReportClient()

  //   },
  //   {
  //     reportName: "Corporate Prospects Report",
  //     reportType: "Sales Report",
  //     dateGenerated: "2024-08-10",
  //     onClick: () => downloadCorporateProspectsReportClient()

  //   },
  //   {
  //     reportName: "Performance Review Report",
  //     reportType: "Sales Report",
  //     dateGenerated: "2024-08-15",
  //     onClick: () => downloadPerformanceReviewReportClient()

  //   },
  // ];
  return (
    <ParentComponent>
      <PrimaryHeader
        PrivilagesCondition={
          PrivilagesArray?.length > 0 ? (PrivilagesArray[0].accessLevel == "Full Access" ? true : false) : true
        }
        buttonText="Generate Report"
        buttonIcon={<FaPlus className="mr-2" />}
        onButtonClick={() => {
          if (role == "Admin") {
            setIsModalOpen(true);
          } else {
            setIsModalOpenClient(true);
          }
        }}
      />
      {role == "Admin" ? (
        <div className="bg-white shadow-md rounded-lg">
          <div className="p-4 flex flex-col md:flex-row md:space-x-6 space-y-4 md:space-y-0">
            <div className="relative w-full">
              <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                value={searchTerm}
                onChange={handleSearch}
                placeholder="Search"
                className="border border-gray-300 rounded-lg pl-10 pr-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-[#361D32]"
              />
            </div>

            <div className="w-full sm:w-full md:w-3/12">
              <DropDownCustom
                isClient={true}
                isAligned={true}
                selectedValue={reportFilterOptions.find((option) => option.value === filterType)}
                handleChanges={handleFilterChange}
                options={reportFilterOptions}
                isSearchable={false}
                label="Report Type"
              />
            </div>
          </div>

          {loader ? (
            <div className="p-10">
              <Loader />
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-left">
                <thead className="bg-[#361D3214]">
                  <tr className="text-gray-500 text-sm">
                    <th className="px-4 py-4 font-semibold text-gray-600 min-w-[200px]">Report Name</th>
                    <th className="px-4 py-4 text-left  font-semibold text-gray-600 min-w-[180px]">Report Type</th>
                    <th className="py-4 font-semibold text-center text-gray-600 min-w-[150px]">Date Generated</th>
                    <th className="py-4 font-semibold text-center text-gray-600 min-w-[150px]">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredReports?.length > 0 ? (
                    filteredReports.map((report, idx) => (
                      <tr key={idx} className="border-b last:border-none">
                        <td className="p-4 text-gray-800 text-left min-w-[200px]">{report.reportName}</td>
                        <td className="p-4 text-gray-800 text-left min-w-[180px]">{report.reportType}</td>
                        <td className="p-4 text-gray-800 text-center min-w-[150px]">
                          {moment(report.createdAt).format("DD-MMM-yy")}
                        </td>
                        <td className="p-4 flex items-center space-x-2 text-center justify-center min-w-[150px]">
                          <button
                            className="flex items-center space-x-1 text-black-500 hover:underline hover:text-blue-500"
                            onClick={() => {
                              getReportById(report.id);
                            }}
                          >
                            <FiDownload className="w-5 h-5" />
                            <span>Download</span>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="p-4 text-center text-gray-500">
                        No reports found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ) : (
        <div className="bg-white shadow-md rounded-lg">
          <div className="p-4 flex flex-col md:flex-row md:space-x-6 space-y-4 md:space-y-0">
            <div className="relative w-full">
              <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                value={searchTerm}
                onChange={handleSearch}
                placeholder="Search"
                className="border border-gray-300 rounded-lg pl-10 pr-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-[#361D32]"
              />
            </div>

            <div className="w-full sm:w-full md:w-3/12">
              <DropDownCustom
                isClient={true}
                isAligned={true}
                selectedValue={reportFilterOptionsClients.find((option) => option.value === filterType)}
                handleChanges={handleFilterChange}
                options={reportFilterOptionsClients}
                isSearchable={false}
                label="Report Type"
              />
            </div>
          </div>

          {loader ? (
            <div className="p-10">
              <Loader />
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-left">
                <thead className="bg-[#361D3214]">
                  <tr className="text-gray-500 text-sm">
                    <th className="px-4 py-4 font-semibold text-gray-600 min-w-[200px]">Report Name</th>
                    <th className="px-4 py-4 text-left  font-semibold text-gray-600 min-w-[180px]">Report Type</th>
                    <th className="py-4 font-semibold text-center text-gray-600 min-w-[150px]">Date Generated</th>
                    <th className="py-4 font-semibold text-center text-gray-600 min-w-[150px]">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredReports?.length > 0 ? (
                    filteredReports.map((report, idx) => (
                      <tr key={idx} className="border-b last:border-none">
                        <td className="p-4 text-gray-800 text-left min-w-[200px]">{report.name}</td>
                        <td className="p-4 text-gray-800 text-left min-w-[180px]">{report.reportType}</td>
                        <td className="p-4 text-gray-800 text-center min-w-[150px]">
                          {moment(report.createdAt).format("DD-MMM-yy")}
                        </td>
                        <td className="p-4 flex items-center space-x-2 text-center justify-center min-w-[150px]">
                          <button
                            className="flex items-center space-x-1 text-black-500 hover:underline hover:text-blue-500"
                            onClick={() => {
                              getReportByIdClient(report.id, report.reportType);
                            }}
                          >
                            <FiDownload className="w-5 h-5" />
                            <span>Download</span>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="p-4 text-center text-gray-500">
                        No reports found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
      <ReportManagementModal
        isOpen={isModalOpen}
        heading={"Generate Report"}
        onClose={() => {
          setIsModalOpen(false);
          getAllReports();
        }}
      />
      <ReportManagementModalClient
        isOpen={isModalOpenClient}
        heading={"Generate Report"}
        onClose={() => {
          setChecker(!checker);
          setIsModalOpenClient(false);
        }}
      />
    </ParentComponent>
  );
};

export default ReportManagementTable;
